/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { useDispatch, useSelector } from "react-redux";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
import Button from "components/CustomButtons/Button.js";
import Build from "@material-ui/icons/Build";
import FooterSection from "trade-customer-portal/views/footer.js"
// views for this page
import McCannRegisterInput from "../../views/RegisterPage/Classes/RegisterInputClass.js";
import HeaderSection from "trade-customer-portal/views/header.js";

import LoadingData from '../lottieLoading.js';

// styling 
import style from "assets/jss/CustomerTradePortal/views/adminPageStyle";
const useStyles = makeStyles(style);


// Landing Page for customer trade portal 
export default function RegisterPage() {

    const loading = useSelector(state => state.userReducer.loadingPage);


    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    });
    const classes = useStyles();


        return (
            <div >
                <HeaderSection />

                <Parallax
                    image={require("assets/img/ac.jpg")}
                    filter="dark"
                    xsmall
                >
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem
                                md={7}
                                sm={8}
                                className={classNames(
                                    classes.mlAuto,
                                    classes.mrAuto,
                                    classes.textCenter
                                )}
                            >
                                <h1 className={classes.title}> Customer Registration </h1>
                            </GridItem>
                        </GridContainer>

                    </div>
                </Parallax>


                <div className={classNames(classes.main, classes.mainRaised)} >
                    <div className={classes.container} >
                        <McCannRegisterInput />
                    </div>
                </div>


                <FooterSection />
            </div>
        );



    
}


